// ExternalCompanyPayroll.jsx
// 외부 회사별 급여 관리 페이지 (/admin/ext/:code/payroll)
// URL의 code 파라미터를 읽어 해당 회사의 급여 관리를 표시합니다.

import { useParams } from 'react-router-dom';
import PayrollManagement from './PayrollManagement';

export default function ExternalCompanyPayroll() {
  const { code } = useParams(); // URL 파라미터에서 회사 코드 추출
  return <PayrollManagement companyCode={code.toUpperCase()} />;
}
